import styled from 'styled-components';

import Button from '../../components/Button';

export const Document = styled.div`
	display: flex;
	flex-direction: column;
	padding: 16px;
	height: calc(100vh - 60px);
	flex: 1;
`;

Document.Paragraph = styled.p`
	font-weight: 400;
	font-size: 16px;
	line-height: 20px;
	color: #000000;
`;

Document.Title = styled.p`
	font-weight: 500;
	font-size: 18px;
	line-height: 20px;
	color: #000000;
`;
Document.FooterContainer = styled.div`
	position: fixed;
	bottom: 0;
	background-color: white;
	width: 100%;
`;

Document.Footer = styled.div`
	display: flex;
    height: 100%;
	padding: 16px;
    flex: 1;
    flex-direction: column;
    justify-content: flex-end;
`;

Document.Footer.SignatureBox = styled.div`
	height: 160px;
	text-align: ${({ hasSignature }) => hasSignature ? 'center' : 'left'};
	border: 1px solid #D9E1E8;
	cursor: pointer;
	background: white;
	border-radius: 8px;
	padding: 8px 16px;
`;

Document.Footer.SignatureBox.Placeholder = styled.span`
	fnt-weight: 400;
	font-size: 16px;
	line-height: 24px;
	color: #767B7F;
`;

Document.Footer.SignatureBox.Image = styled.img`
	width: 260px;
	height: 140px;
`;

Document.Footer.PatientInfo = styled.div`
	display: flex;
	margin-top: 16px;
	flex-direction: column;
`;

Document.Footer.PatientInfo.Name = styled.span`
	font-weight: 500;
	font-size: 16px;
	line-height: 20px;
	color: #26282A;
`;

Document.Footer.PatientInfo.Cpf = styled.span`
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	color: #4E5255;
	margin-top: 8px;
`;

Document.Footer.Button = styled(Button)`
	margin-top: 16px;
`;
